import 'firebase/analytics';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/messaging';
import 'firebase/performance';
import 'firebase/remote-config';
import 'firebase/storage';

let useEmulator = false;
export function enableEmulator() {
  console.log('using firebase emulator');
  const auth = firebase.auth();
  auth.useEmulator('http://localhost:9099');
  const firestore = firebase.firestore();
  firestore.useEmulator('localhost', 8080);
  const storage = firebase.storage();
  // NOTE: cloud storage emulator does not support
  // signed urls, so any requests for that will fail.
  storage.useEmulator('localhost', 9199);
  useEmulator = true;
}
/**
 * Get the storage object for the given bucket.
 * @param bucket
 * @returns
 */
export function getStorageForBucket(bucket: string) {
  const storage = firebase.app().storage(`gs://${bucket}`);
  // You have to set the storage object to use the emulator
  // when you get the object this way, because for some reason
  // setting it above (in useEmulator()) does not apply.
  if (useEmulator) {
    storage.useEmulator('localhost', 9199);
  }
  return storage;
}
export { firebase };
